(function () {
  const DATASTAR_SIGNAL_PATCH_EVENT = "datastar-signal-patch";

  function patchMatchesSignalFilter(patch, filter, prefix = "") {
    if (!patch || typeof patch !== "object") {
      return false;
    }
    const include = filter?.include && typeof filter.include.test === "function"
      ? filter.include
      : null;
    const exclude = filter?.exclude && typeof filter.exclude.test === "function"
      ? filter.exclude
      : null;
    return Object.entries(patch).some(([key, value]) => {
      const path = prefix ? `${prefix}.${key}` : key;
      if (include) {
        if (include.test(path)) {
          return true;
        }
      } else if (exclude) {
        if (!exclude.test(path)) {
          return true;
        }
      }
      return value && typeof value === "object" && patchMatchesSignalFilter(value, filter, path);
    });
  }

  function createSignalPatchPersistor(options = {}) {
    const target = options.target && typeof options.target.addEventListener === "function"
      ? options.target
      : document;
    const isReady = typeof options.isReady === "function" ? options.isReady : () => true;
    const persist = typeof options.persist === "function" ? options.persist : () => {};
    const filter = options.filter && typeof options.filter === "object" ? options.filter : null;
    const shouldPersistPatch = typeof options.shouldPersistPatch === "function"
      ? options.shouldPersistPatch
      : (patch) => patchMatchesSignalFilter(patch, filter);
    const state = {
      bound: false,
    };

    function handleSignalPatch(event) {
      if (!isReady()) {
        return;
      }
      const patch = event?.detail;
      if (!shouldPersistPatch(patch)) {
        return;
      }
      persist();
    }

    function bind() {
      if (state.bound) {
        return;
      }
      target.addEventListener(DATASTAR_SIGNAL_PATCH_EVENT, handleSignalPatch);
      state.bound = true;
    }

    function dispose() {
      if (!state.bound) {
        return;
      }
      target.removeEventListener?.(DATASTAR_SIGNAL_PATCH_EVENT, handleSignalPatch);
      state.bound = false;
    }

    return Object.freeze({
      bind,
      dispose,
    });
  }

  function createDebouncedSignalPatchPersistor(options = {}) {
    const delayMs = Number.isFinite(options.delayMs) ? Math.max(0, options.delayMs) : 150;
    const persist = typeof options.persist === "function" ? options.persist : () => {};
    const pageLifecycle = options.pageLifecycle
      && typeof options.pageLifecycle.addEventListener === "function"
      ? options.pageLifecycle
      : null;
    let timer = 0;
    let pending = false;
    let lifecycleBound = false;

    function clearScheduledTimer() {
      if (!timer) {
        return;
      }
      globalThis.clearTimeout?.(timer);
      timer = 0;
    }

    function runPersist() {
      timer = 0;
      if (!pending) {
        return false;
      }
      pending = false;
      persist();
      return true;
    }

    function schedulePersist() {
      clearScheduledTimer();
      pending = true;
      timer = globalThis.setTimeout?.(runPersist, delayMs);
    }

    function flush() {
      clearScheduledTimer();
      return runPersist();
    }

    function clearTimer() {
      clearScheduledTimer();
      pending = false;
    }

    const binding = createSignalPatchPersistor({
      ...options,
      persist: schedulePersist,
    });

    function bind() {
      binding.bind();
      if (pageLifecycle && !lifecycleBound) {
        pageLifecycle.addEventListener("pagehide", flush);
        lifecycleBound = true;
      }
    }

    function dispose() {
      clearTimer();
      binding.dispose();
      if (pageLifecycle && lifecycleBound) {
        pageLifecycle.removeEventListener?.("pagehide", flush);
        lifecycleBound = false;
      }
    }

    return Object.freeze({
      bind,
      dispose,
      clearTimer,
      flush,
      schedulePersist,
    });
  }

  window.__fishystuffDatastarPersist = Object.freeze({
    DATASTAR_SIGNAL_PATCH_EVENT,
    patchMatchesSignalFilter,
    createSignalPatchPersistor,
    createDebouncedSignalPatchPersistor,
  });
})();
